"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unpackToRawClusterData = exports.packRawClusterData = exports.ClusterDataV1 = exports.ClusterDataV2 = void 0;
const base_1 = require("@ckb-lumos/base");
const codec_1 = require("@ckb-lumos/codec");
const helpers_1 = require("../helpers");
exports.ClusterDataV2 = codec_1.molecule.table({
    name: base_1.blockchain.Bytes,
    description: base_1.blockchain.Bytes,
    mutantId: base_1.blockchain.BytesOpt,
}, ['name', 'description', 'mutantId']);
exports.ClusterDataV1 = codec_1.molecule.table({
    name: base_1.blockchain.Bytes,
    description: base_1.blockchain.Bytes,
}, ['name', 'description']);
function packRawClusterData(packable) {
    return exports.ClusterDataV2.pack({
        name: (0, helpers_1.bytifyRawString)(packable.name),
        description: (0, helpers_1.bytifyRawString)(packable.description),
        mutantId: packable.mutantId,
    });
}
exports.packRawClusterData = packRawClusterData;
function unpackToRawClusterData(unpackable) {
    try {
        const decoded = exports.ClusterDataV2.unpack(unpackable);
        return {
            name: (0, helpers_1.bufferToRawString)(decoded.name),
            description: (0, helpers_1.bufferToRawString)(decoded.description),
            mutantId: decoded.mutantId,
        };
    }
    catch {
        const decoded = exports.ClusterDataV1.unpack(unpackable);
        return {
            name: (0, helpers_1.bufferToRawString)(decoded.name),
            description: (0, helpers_1.bufferToRawString)(decoded.description),
        };
    }
}
exports.unpackToRawClusterData = unpackToRawClusterData;
//# sourceMappingURL=cluster.js.map